import React, { Component } from 'react';
import { Form, Modal } from 'antd'

import InputCustom from '../../components/default/InputCustom'
import TextAreaCustom from '../../components/default/TextAreaCustom'
import ButtonCustom from '../../components/default/ButtonCustom'

import { connect } from 'react-redux'
import { sendContact } from '../../actions/contact'

const confirm = Modal.confirm;

class Contact extends Component {
    state = {
        messageData: {
            title: "",
            email: "",
            message: ""
        }
    }
    onInputChange = (event) => {
        const name = event.target.name
        let messageData = { ...this.state.messageData }
        messageData[name] = event.target.value
        this.setState({messageData: messageData})
    }
    onSubmit = (e) => {
        e.preventDefault()
        let messageData = { ...this.state.messageData }
        const send = this.props
        confirm({
            title: 'กรุณายืนยันเพื่อทำการส่งข้อความ',
            okText: "ยืนยัน",
            cancelText: "ยกเลิก",
            onOk() {
                send.sendContact(messageData)
            },
            onCancel() {},
        });
    }
    render() {
        return (
            <div className="contact-page-wrap">
                <div className="contact-page">
                    <div className="page-list-title gapb-32">ติดต่อเรา<div className="hr"></div></div>
                    <div className="contact-page-content is-row is-sm-row">
                        <div className="is-68 is-sm-100 send-message-wrap">
                            <div className="contact-page-content-title">ส่งข้อความ</div>
                            <Form onSubmit={this.onSubmit}>
                                <InputCustom
                                    label="อีเมล"
                                    placeholder="อีเมล"
                                    size="large"
                                    type="text"
                                    required
                                    marginBottom="16"
                                    labelColor="65"
                                    name="email"
                                    onChange={this.onInputChange}
                                />
                                <InputCustom
                                    label="หัวข้อ"
                                    placeholder="หัวข้อ"
                                    size="large"
                                    type="text"
                                    required
                                    marginBottom="16"
                                    labelColor="65"
                                    name="title"
                                    onChange={this.onInputChange}
                                />
                                <TextAreaCustom
                                    label="ข้อความ"
                                    labelColor="65"
                                    placeholder="ข้อความ"
                                    rows="7"
                                    marginBottom="32"
                                    resize
                                    name="message"
                                    onChange={this.onInputChange}
                                />
                                <ButtonCustom
                                    borderRadius="4"
                                    color="blue"
                                    label="ส่งข้อความ"
                                    fontSize={16}
                                    fontWeight="large"
                                    size="extra"
                                    className="center"
                                    htmlType="submit"
                                />
                            </Form>
                        </div>
                        <div className="is-32 is-sm-100 contact-info-wrap">
                            <div className="contact-page-content-title">ติดต่อ</div>
                            <div className="contact-info-item">
                                <div className="contact-info-title">เวลาทำการ:</div>
                                <div className="contact-info-detail">จันทร์ - ศุกร์: 8.30 น. – 16.30 น.</div>
                            </div>
                            <div className="contact-info-item">
                                <div className="contact-info-title">โทรศัพท์:</div>
                                <div className="contact-info-detail">053-875-527</div>
                            </div>
                            <div className="contact-info-item">
                                <div className="contact-info-title">อีเมล:</div>
                                <div className="contact-info-detail">Innovativeindex.mju@gmail.com</div>
                            </div>
                            <div className="contact-info-item">
                                <div className="contact-info-title">ที่อยู่:</div>
                                <div className="contact-info-detail">63 หมู่ 4 ต.หนองหาร อ.สันทราย จ.เชียงใหม่ 50290</div>
                            </div>
                            <div className="social-contact-wrap">
                                    <ButtonCustom
                                        color="transparent"
                                        iconImage="ic-facebook-gray.svg"
                                        iconButton
                                        href="/"
                                        className="gapr-16"
                                    />
                                    <ButtonCustom
                                        color="transparent"
                                        iconImage="ic-twitter-gray.svg"
                                        iconButton
                                        href="/"
                                        className="gapr-16"
                                    />
                                    <ButtonCustom
                                        color="transparent"
                                        iconImage="ic-google-gray.svg"
                                        iconButton
                                        href="/"
                                        className="gapr-16"
                                    />
                                    <ButtonCustom
                                        color="transparent"
                                        iconImage="ic-line-gray.svg"
                                        iconButton
                                        href="/"
                                        className="gapr-16"
                                    />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return{
        auth: state.auth,
        user: state.user,
    }
}

const mapDispatchToProps = {
    sendContact
}

export default connect(mapStateToProps,mapDispatchToProps)(Contact)
